import { render, staticRenderFns } from "./TheMainMailCenterCrud.vue?vue&type=template&id=2ea4917e"
import script from "./TheMainMailCenterCrud.vue?vue&type=script&lang=js"
export * from "./TheMainMailCenterCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports